module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_10X_Section2.ca8f1c97.png";